import axios, { AxiosPromise } from 'axios';
import { injectable } from '@servicetitan/react-ioc';

export interface ClientContext {
    titanGuid?: string;
    tenantId?: string;
    tenantName?: string;
    userId?: string;
    isPilot?: boolean;
    deployment?: string;
}

@injectable()
export class ClientContextApi {
    getClientContext(): AxiosPromise<ClientContext> {
        return axios.get<ClientContext>('/client-context');
    }
}
